import React from 'react';
import './SuccessPopup.sass';
import ReactHtmlParser from 'react-html-parser';
import { transformSource } from '../../utils/helpers';

import { ReactComponent as CloseIco } from '../../assets/img/success-popup/popup-close-dark.svg';
import { ReactComponent as DudeRed } from '../../assets/img/dude/dude-success.svg';

interface Props {
	isActive: boolean;
	closePopup: () => {};
	title: string;
	content: string;
}

function SuccessPopup({ isActive, closePopup, title, content }: Props) {
	return (
		// Use success-popup--active class to show success popup
		<div className={`success-popup${isActive && ' success-popup--active'}`}>
			<div className="success-popup__overlay" />
			<div className="success-popup__inner">
				<div className="success-popup__close">
					<CloseIco onClick={closePopup} />
				</div>
				<h2 className="uikit-heading-lg success-popup__heading">{title}</h2>
				<p className="uikit-text-regular success-popup__message">
					{ReactHtmlParser(content, {
						transform: transformSource,
					})}
				</p>
				<div className="success-popup__illustr">
					<DudeRed />
				</div>
			</div>
		</div>
	);
}

export default SuccessPopup;
